import React from 'react';

import { Box, ThemeIcon, Tooltip } from '@mantine/core';
import { IconAlertCircle, IconCheck } from '@tabler/icons-react';

interface WeekEventStatusBadgeProps {
  assigned: boolean;
  fg: string;
}

const WeekEventStatusBadge = ({ assigned, fg }: WeekEventStatusBadgeProps): JSX.Element => {
  if (assigned) {
    return (
      <Tooltip label='Workout assigned' color='kiloBlue' withArrow position='top' withinPortal>
        <ThemeIcon
          color='green'
          variant='filled'
          radius='xl'
          size='xs'
          aria-label='Workout assigned'
          sx={{ flexShrink: 0 }}
        >
          <IconCheck size={12} />
        </ThemeIcon>
      </Tooltip>
    );
  }

  return (
    <Tooltip label='No workout assigned' color='kiloBlue' withArrow position='top' withinPortal>
      <Box sx={{ display: 'flex', flexShrink: 0 }} aria-label='No workout assigned'>
        <IconAlertCircle size={16} color={fg} />
      </Box>
    </Tooltip>
  );
};

export default WeekEventStatusBadge;
